import { render, staticRenderFns } from "./ProFormas.vue?vue&type=template&id=26ac48eb"
import script from "./ProFormas.vue?vue&type=script&lang=js"
export * from "./ProFormas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports